import { NavigationItemType, SubMenuItemType } from "../../types";
import { MenuItemType } from "../constants";

export const useMenuItemLogic = () => {
  const isQuickLinks = (item: NavigationItemType): boolean => item.name === "Quick Links";

  const getFirstItemHref = (item: NavigationItemType): string =>
    item.items?.[0]?.href || item.href || "#";

  const getFirstNestedItemHref = (item: SubMenuItemType): string =>
    item.items?.[0]?.href || item.href || "#";

  const isExternalLink = (href?: string): boolean =>
    href?.startsWith("http://") || href?.startsWith("https://") || false;

  const hasSubItems = (item: NavigationItemType | SubMenuItemType): boolean =>
    !!(item.items && item.items.length > 0);

  const getMenuKey = (parentKey: string, itemName: string): string => `${parentKey}.${itemName}`;

  const getMenuItemType = (item: NavigationItemType): MenuItemType => {
    if (!hasSubItems(item)) {
      return MenuItemType.SIMPLE;
    }
    if (isQuickLinks(item)) {
      return MenuItemType.QUICK_LINKS;
    }
    return MenuItemType.WITH_SUBITEMS;
  };

  return {
    isQuickLinks,
    getFirstItemHref,
    getFirstNestedItemHref,
    isExternalLink,
    hasSubItems,
    getMenuKey,
    getMenuItemType,
  };
};
